<div
  *transloco="let t; read: 'widgets.analytic-item-selector'"
  class="analytic-item-selector__wrapper"
>
  <div>
    <h3>{{ t('explore') }}</h3>

    <div class="analytic-item-selector__items-wrapper">
      @for (radio of analyticItemRadios; track radio) {
        <div class="analytic-item-selector__radio-button">
          <xi-radio
            color="CX"
            [name]="radio.name"
            [label]="radio.label"
            [value]="radio.value"
            [disabled]="radio.disabled"
            [checked]="radio.checked"
            (onChange)="setAnalyticType(radio.value)"
            [matTooltip]="radio.tooltip"
            matTooltipPosition="right"
          ></xi-radio>
        </div>
      }
    </div>
  </div>

  @if (subtypeSelectionMode !== 'none') {
    <div>
      @if (isBlankEnabled && customFieldSelected && !widgetDataSource.isSocial) {
        <h3>{{ t('blank-fields') }}</h3>
        <div class="analytic-item-selector__blanks-div">
          <xi-checkbox
            color="CX"
            [label]="t('include-blank')"
            [(ngModel)]="isBlankSelected"
            [disabled]="disableBlankSelector"
            [matTooltip]="disabledBlankTooltip"
            (onChange)="isBlankSelected = $event.detail.target.checked"
          ></xi-checkbox>
        </div>
      }
      @if (!widgetDataSource.isSocial || selectedAnalyticItem.analyticItem === 'taxonomy') {
        <div>
          @switch (subtypeSelectionMode) {
            @case ('multiple') {
              <h3>{{ t('exclude') }}</h3>
              <div class="analytic-item-selector__items-wrapper">
                @for (radio of subtypeRadios; track radio) {
                  <div class="analytic-item-selector__subtypes-checkbox">
                    @if (radio.visible) {
                      <div>
                        <xi-checkbox
                          color="CX"
                          [value]="radio.value"
                          [label]="radio.label | titlecase"
                          [checked]="radio.checked"
                          (onChange)="setAnalyticSubType($event.detail.target.checked, radio.value)"
                        >
                        </xi-checkbox>
                      </div>
                    }
                  </div>
                }
              </div>
            }
            @case ('single') {
              <h3>
                {{ selectedAnalyticItem.displayName }}
              </h3>
              <div
                [ngClass]="
                  isBlankEnabled && customFieldSelected
                    ? 'analytic-item-selector__items-wrapper--short'
                    : 'analytic-item-selector__items-wrapper'
                "
              >
                @for (radio of subtypeRadios; track radio) {
                  <div class="analytic-item-selector__radio-button">
                    @if (radio.visible) {
                      <xi-radio
                        color="CX"
                        [name]="radio.name"
                        [value]="radio.value"
                        [label]="radio.label | titlecase"
                        [checked]="radio.checked"
                        [disabled]="radio.disabled"
                        (onChange)="setAnalyticSubType($event.detail.target.checked, radio.value)"
                      ></xi-radio>
                    }
                  </div>
                }
              </div>
            }
          }
        </div>
      }
    </div>
  }
</div>
